/**
 * advert helpers — чистые функции для вычислений
 */

import {
  PUID,
  getCurrentCode,
  DEFAULT_AD_TYPE,
  AD_TYPES_WITHOUT_PLUG,
  DEV_MODE_URL_PARAM,
  getCurrentScrollLoad,
} from '../config'

import { getLocalStorageItem, STORAGE_KEYS } from '@shared/lib/helpers/storage'

import type { BuildNodeIdParams, ResolveAdCodeParams, ResolveScrollLoadParam } from '../types'

export const resolveAdCode = (params: ResolveAdCodeParams): [number, number] => {
  const { typeCurrent, type, isMobile } = params
  const defaultCode = getCurrentCode(DEFAULT_AD_TYPE, isMobile)
  const code = getCurrentCode(typeCurrent, isMobile) ?? getCurrentCode(type, isMobile) ?? defaultCode
  const resolved = Array.isArray(code) ? code : defaultCode
  return resolved as [number, number]
}

export const resolveAdScrollLoad = (params: ResolveScrollLoadParam): number | false => {
  const { typeCurrent, type, isMobile, forcedValue } = params

  if (forcedValue !== undefined && (typeof forcedValue === 'number' || typeof forcedValue === 'boolean')) {
    return forcedValue === true ? 100 : forcedValue
  }

  const defaultCode = getCurrentScrollLoad(DEFAULT_AD_TYPE, isMobile)
  const state = getCurrentScrollLoad(typeCurrent, isMobile) ?? getCurrentScrollLoad(type, isMobile) ?? defaultCode
  return state ? 100 : false
}

export const buildNodeId = (params: BuildNodeIdParams): string => {
  const { begunAutoPad, begunBlockId, storeCurrentPage, dynamicCount } = params
  return `block_pad_id_${begunAutoPad}_${begunBlockId}_${storeCurrentPage}__${dynamicCount}`
}

// begun-scroll-rate: Загрузка рекламного кода за 1 и более экранов до видимой области рекламного места
// Его значения - от 0 до бесконечности
// 0 - это дефолтное значение, означает, что баннер покажется при достижении видимости в один пиксел хотя бы
// 100 - за один экран
// 200 - за два
export const buildOptionsSsp = (begunAutoPad: number, begunBlockId: number, begunScrollRate?: number | false) => ({
  'begun-auto-pad': begunAutoPad,
  'begun-block-id': begunBlockId,
  'begun-scroll-rate': typeof begunScrollRate == 'number' ? begunScrollRate : undefined,
})

export const buildOptionsPuid = (isMobile: boolean | null) => ({
  puid6: isMobile ? PUID.afisha_6 : PUID.rests_6,
  puid18: isMobile ? PUID.afisha_18 : PUID.rests_18,
})

export const checkIsDevMode = (): boolean =>
  typeof window !== 'undefined' && window.location.search.indexOf(DEV_MODE_URL_PARAM) > 0

export const checkIsAdvDisabled = (): boolean => Boolean(getLocalStorageItem(STORAGE_KEYS.ADVERT_DISABLED))

export const computeShowPlugAds = (effectiveShowAdv: boolean, typeCurrent: string): boolean =>
  effectiveShowAdv === false && !AD_TYPES_WITHOUT_PLUG.includes(typeCurrent)
